import React from 'react';

/**
 * Reusable loading spinner component
 * @param {string} text - Optional text to display below the spinner
 * @param {string} size - Size of the spinner: 'sm', 'md', 'lg' (default: 'md')
 * @param {string} className - Additional CSS classes for the container
 */
function LoadingSpinner({ text = 'Loading...', size = 'md', className = '' }) {
    const sizeClasses = {
        sm: 'h-6 w-6',
        md: 'h-12 w-12',
        lg: 'h-16 w-16'
    };

    const textSizeClasses = {
        sm: 'text-sm',
        md: 'text-lg',
        lg: 'text-xl'
    };

    return (
        <div className={`flex items-center justify-center ${className}`}>
            <div className="flex flex-col items-center gap-4">
                <div className={`animate-spin rounded-full border-b-2 border-customeOrange ${sizeClasses[size]}`}></div>
                {text && <p className={`text-customeBlack ${textSizeClasses[size]}`}>{text}</p>}
            </div>
        </div>
    );
}

export default LoadingSpinner;
